export const adevintaSites = [
  {
    href: 'https://www.coches.net',
    content: 'coches.net'
  },
  {
    href: 'https://www.milanuncios.com',
    content: 'Milanuncios'
  }
]

export const LINKS = [
  {
    title: 'FOOTER.LINK.MOTOS.TITLE_ABOUT',
    urls: [
      {
        text: 'FOOTER.LINK.MOTOS.ABOUT_US',
        url: 'https://comunicacion.coches.net/conocenos/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.TAGLINE',
        url: 'https://www.coches.net/la-mejor-oferta-de-coches/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.DOWNLOAD_APPS',
        url: 'https://comunicacion.coches.net/descarga-app/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.PRESS',
        url: 'https://www.coches.net/blog-profesionales/categoria/notas-de-prensa/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.WORK_WITH_US',
        url: 'https://www.adevinta.es/careers'
      },
      {
        text: 'FOOTER.LINK.MOTOS.SITEMAP',
        url: '/mapa-web.aspx'
      }
    ]
  },
  {
    title: 'FOOTER.LINK.MOTOS.TITLE_FIND',
    urls: [
      {
        text: 'FOOTER.LINK.MOTOS.SECOND_HAND',
        url: '/segunda-mano/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.NEW',
        url: '/nuevas/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.CLASSIC',
        url: '/segunda-mano/clasicas/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.SCOOTERS_SECOND_HAND',
        url: '/segunda-mano/scooter/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.QUADS_SECOND_HAND',
        url: '/segunda-mano/quads/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.BUGGIES_SECOND_HAND',
        url: '/segunda-mano/buggy/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.PIT_BIKES_SECOND_HAND',
        url: '/segunda-mano/minimotos/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.NEWS',
        url: '/noticias/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.DEALERS_LIST',
        url: '/concesionarios/'
      }
    ]
  },
  {
    title: 'FOOTER.LINK.MOTOS.TITLE_SELL',
    urls: [
      {
        text: 'FOOTER.LINK.MOTOS.SELL',
        url: '/vender-mi-moto'
      }
    ]
  },
  {
    title: 'FOOTER.LINK.MOTOS.TITLE_PROS',
    urls: [
      {
        text: 'FOOTER.LINK.MOTOS.SIGNIN',
        url: 'https://pro.motos.net/login.aspx'
      },
      {
        text: 'FOOTER.LINK.MOTOS.ADVERTISE',
        url: 'https://profesional.coches.net/anunciate-como-profesional/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.HELP_FOR_PROS',
        url: 'https://ayudaprofesionales.coches.net/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.BLOG_FOR_PROS',
        url: 'https://www.coches.net/blog-profesionales/'
      }
    ]
  },
  {
    title: 'FOOTER.LINK.MOTOS.TITLE_GUIDES',
    urls: [
      {
        text: 'FOOTER.LINK.MOTOS.WHAT_TO_BUY',
        url: '/noticias/que-moto-me-compro-guia-practica'
      },
      {
        text: 'FOOTER.LINK.MOTOS.SELL_AND_BUY_PROCEDURES',
        url: '/tramites-compra-venta-motos/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.FAQ',
        url: '/Ayuda.aspx'
      },
      {
        text: 'FOOTER.LINK.MOTOS.TECH_INFO',
        url: '/fichas_tecnicas/buscador/'
      },
      {
        text: 'FOOTER.LINK.MOTOS.COMPARATOR',
        url: '/fichas_tecnicas/comparar.aspx'
      }
    ]
  }
]

export const POLICIES_LINKS = [
  {title: 'FOOTER.LINK.MOTOS.CONDITIONS', url: '/condiciones-de-uso/'},
  {
    title: 'FOOTER.LINK.MOTOS.COOKIES_POLICY',
    url: '/condiciones-de-uso/#cookies'
  },
  {
    title: 'FOOTER.LINK.MOTOS.PRIVACY_POLICY',
    url: '/condiciones-de-uso/#privacidad'
  },
  {
    title: 'FOOTER.LINK.MOTOS.TRANSPARENCY',
    url: '/transparencia/'
  }
]
